<script setup>
import {Link, usePage} from '@inertiajs/vue3';
import {ref, onMounted, onUnmounted, computed} from 'vue';
import {visionsDetail, socialMediasDetail} from '@/Stores/Data.js';
import App from '@/Layouts/App.vue';
import imageHelper from '@/Helpers/image_helper.js';
import VisionSection from "@/Components/VisionSection.vue";
import ContentDetail from "@/Components/Detail/ContentDetail.vue";

const { getImage } = imageHelper.methods;

const ourVision = computed(() => usePage().props.ourVision);
const setting = computed(() => usePage().props.setting);
const sharingSocialMedia = computed(() => usePage().props.sharing);

const props = defineProps({
    serviceDetail: Array,
});

const ourVisionSetting = computed(() => {
    return setting.value.filter(item => item.key === 'our_vision');
});

const isMobile = ref(window.innerWidth < 800);
const isSticky = ref(false);

const checkScreenSize = () => {
    isMobile.value = window.innerWidth < 800;
};

const updateSticky = () => {
    isSticky.value = window.scrollY > 100;
};

onMounted(() => {
    checkScreenSize();
    updateSticky();
    window.addEventListener('resize', checkScreenSize);
    window.addEventListener('scroll', updateSticky);
});

onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
    window.removeEventListener('scroll', updateSticky);
});
</script>

<template>
    <App class="bg-grayWhiteColor">
        <template v-for="item in serviceDetail">
            <section class="relative bg-cover bg-center w-full height-banners" :style="{ backgroundImage: `url(${getImage(item.image_banner)})` }">
                <div class="absolute top-0 w-full h-full flex flex-col justify-center items-center gap-y-1 p-3 md:p-0">
                    <h1 class="text-title text-primaryColor text-center">{{ item.title }}</h1>
                    <p class="text-description text-grayBlackColor text-center width-description-banner">
                        {{ item.excerpt }}
                    </p>
                </div>
            </section>
        </template>

        <section class="content-body content-padding my-5 md:my-10">
            <div class="w-full flex gap-3 md:gap-6 xl:gap-10" :class="{ 'flex-col w-full': isMobile }">
                <div class="w-full md:w-[75%]">
                    <div class="w-full grid justify-start gap-y-2 md:gap-y-3">
                        <template v-for="item in serviceDetail">
                            <h1 class="text-title-content leading-8 md:leading-10">{{ item.sub_title }}</h1>
                        </template>

                        <ContentDetail
                        :serviceDetail="serviceDetail"
                        />
                    </div>
                </div>

                <div class="w-full md:w-[25%]">
                    <div class="sidebar" :class="{ 'sticky-sidebar': isSticky }">
                        <div class="w-full grid justify-start gap-y-3 md:gap-y-5">
                            <div class="flex justify-start items-center gap-x-3 mb-0 md:mb-3">
                                <div class="w-1 h-7 rounded-r-md bg-primaryColor"></div>
                                <template v-for="item in ourVisionSetting">
                                    <h1 class="text-title-content leading-8 md:leading-10">{{item.value}}</h1>
                                </template>
                            </div>

                            <div class="grid grid-cols-1 gap-3 md:gap-y-[20px]">
                                <template v-for="(item, index) in ourVision" :key="index">
                                    <VisionSection
                                    :index="index"
                                    :icon="item.image_thumbnail"
                                    :title="item.title"
                                    :description="item.description"
                                    />
                                </template>
                            </div>

                            <div class="flex gap-x-2 justify-start items-center bg-white p-5 shadow-article border border-primaryColor/20 transition-transform duration-500 ease-in-out no-hover">
                                <h2 class="text-primary md:text-secondary font-bold">ចែករំលែក</h2>
                                <div class="flex gap-x-2">
                                    <template v-for="(item, index) in sharingSocialMedia" :key="index">
                                        <a target="_blank" :href="item.description">
                                            <img class="h-5 transition-transform transform hover:scale-110" :src="getImage(item.image_thumbnail)" alt="Icon sharing">
                                        </a>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </App>
</template>

<style scoped>
@media (min-width: 641px) {
    .no-hover:hover {
        transform: translateY(-10px);
    }
}
</style>
